import React from 'react'

import { ETFIcons } from '@acorns/icons'

import { PortfolioSecurityAllocation } from 'generated/types'
import { TestIDs } from 'test/utils/testIds'
import { formatPercentage } from 'utils/number/percentage'

import {
  EtfContainer,
  EtfSymbol,
  Label,
  StyledEtfSymbol,
  TitleContainer,
  Value,
} from './styled-components'

type Props = {
  disabled: boolean
  etf: PortfolioSecurityAllocation
  hasEtfPercent?: boolean
}

const ETFItem = (props: Props) => {
  const etfSymbol = props.etf?.security?.symbol
  return (
    <EtfContainer
      disabled={props.disabled}
      key={etfSymbol}
      data-testid={TestIDs.PREVIEW_PORTFOLIO.PORTFOLIO_ETF + '_' + etfSymbol}
    >
      <>
        {ETFIcons[etfSymbol] !== undefined && (
          <div>
            <StyledEtfSymbol icon={ETFIcons[etfSymbol]} width="68px" height="68px" />
          </div>
        )}
        <TitleContainer hasEtfPercent={props.hasEtfPercent}>
          <Label isBold={true}>{props.etf?.security?.displayName}</Label>
          <EtfSymbol>{etfSymbol}</EtfSymbol>
        </TitleContainer>
        <Value>{formatPercentage(props.etf?.allocationPercent / 100)}</Value>
      </>
    </EtfContainer>
  )
}

export default ETFItem
